(function () {
  "use strict";

  function initModal(modal) {
    if (!modal || modal.dataset.pdpLayerInit === "true") return;
    modal.dataset.pdpLayerInit = "true";

    var closeEls = modal.querySelectorAll("[data-pdp-layer-close]");
    var titleEl = modal.querySelector(".pdp-layer-modal__title");
    var groups = modal.querySelectorAll("[data-pdp-layer-group]");
    var productSets = modal.querySelectorAll("[data-pdp-layer-products]");
    var prevButton = modal.querySelector(".pdp-layer-swiper-prev");
    var nextButton = modal.querySelector(".pdp-layer-swiper-next");
    var addButtons = modal.querySelectorAll("[data-pdp-layer-add]");
    var previouslyFocused = null;
    var previousBodyOverflow = "";
    var layerSwipers = [];

    function isOpen() {
      return modal.classList.contains("is-open");
    }

    function openModal() {
      previouslyFocused = document.activeElement;
      previousBodyOverflow = document.body.style.overflow;
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";

      updateActiveSwiper();

      var closeButton = modal.querySelector(".pdp-layer-modal__close");
      if (closeButton) closeButton.focus();
    }

    function closeModal() {
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      document.body.style.overflow = previousBodyOverflow;

      if (previouslyFocused && typeof previouslyFocused.focus === "function") {
        previouslyFocused.focus();
      }
    }

    function setGroupState(targetGroup, open) {
      groups.forEach(function (group) {
        var isActive = group === targetGroup && open;
        var trigger = group.querySelector("[data-pdp-layer-group-trigger]");
        var description = group.querySelector(".pdp-layer-modal__group-description");
        var chevron = group.querySelector(".pdp-layer-modal__group-chevron");

        group.classList.toggle("pdp-layer-modal__group--active", isActive);

        if (trigger) {
          trigger.setAttribute("aria-expanded", isActive ? "true" : "false");
        }

        setDescriptionOpen(description, isActive);

      });
    }

    function setActiveGroup(activeGroup) {
      var activeKey = activeGroup.getAttribute("data-pdp-layer-group");
      var shouldOpen = !activeGroup.classList.contains("pdp-layer-modal__group--active");

      setGroupState(activeGroup, shouldOpen);

      if (!shouldOpen) {
        return;
      }

      // Show the selected accordion product's title in the modal heading.
      var groupTitle = activeGroup.getAttribute("data-pdp-layer-group-title");
      if (titleEl && groupTitle) {
        titleEl.textContent = groupTitle;
      }

      productSets.forEach(function (set) {
        if (set.getAttribute("data-pdp-layer-products") === activeKey) {
          set.removeAttribute("hidden");
        } else {
          set.setAttribute("hidden", "");
        }
      });

      updateActiveSwiper();
    }

    function refreshActiveSwiper() {
      var activeSwiper = getActiveSwiper();

      if (activeSwiper && typeof activeSwiper.update === "function") {
        activeSwiper.update();
      }

      updateNavState(activeSwiper);
    }

    function updateActiveSwiper() {
      refreshActiveSwiper();

      // Inactive sliders are initialised while their container is display:none
      // (0 width), so the first synchronous update() can still read stale
      // "locked" metrics and leave both arrows disabled. Re-measure on the next
      // frame, once the now-visible slider has laid out, so prev/next reflect
      // the real overflow state.
      window.requestAnimationFrame(refreshActiveSwiper);
    }

    var SWIPER_OPTIONS = {
      slidesPerView: 1.18,
      spaceBetween: 12,
      speed: 450,
      grabCursor: true,
      watchOverflow: true,
      resizeObserver: true,
      observer: true,
      observeParents: true,
      breakpoints: {
        768: { slidesPerView: 2, spaceBetween: 12 },
        1025: { slidesPerView: 2.3, spaceBetween: 12 },
      },
    };

    // Build each group's Swiper lazily, the first time its container is the
    // visible one. Initialising while display:none (0 width) is what left the
    // 2nd/3rd group's slider and arrows broken — a 0-width Swiper locks itself
    // and a later update() does not reliably recover. Deferring creation until
    // the slider actually has layout fixes it.
    function ensureSwiper(setEl) {
      if (!setEl || typeof window.Swiper === "undefined") return null;

      var existing = layerSwipers.find(function (item) {
        return item.el === setEl;
      });
      if (existing) return existing.swiper;

      var swiper = new window.Swiper(setEl, SWIPER_OPTIONS);
      swiper.on("slideChange", function () {
        if (!setEl.hasAttribute("hidden")) {
          updateNavState(swiper);
        }
      });
      layerSwipers.push({ el: setEl, swiper: swiper });
      return swiper;
    }

    function getActiveSwiper() {
      var activeSet = modal.querySelector("[data-pdp-layer-products]:not([hidden])");
      return ensureSwiper(activeSet);
    }

    function updateNavState(swiper) {
      if (!prevButton || !nextButton || !swiper) return;

      // Only toggle the visual (greyed) state. Do NOT set the `disabled`
      // property: a disabled <button> swallows the click entirely, which left
      // the back arrow unresponsive whenever Swiper briefly reported a stale
      // isBeginning on a lazily-built slider. Swiper safely no-ops
      // slidePrev()/slideNext() at the real edges, so clicks are always allowed.
      prevButton.classList.toggle("swiper-button-disabled", swiper.isBeginning);
      nextButton.classList.toggle("swiper-button-disabled", swiper.isEnd);
    }

    function setDescriptionOpen(description, open) {
      if (!description) return;

      if (typeof description.getAnimations === "function") {
        description.getAnimations().forEach(function (animation) {
          animation.cancel();
        });
      }

      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        if (open) {
          description.removeAttribute("hidden");
        } else {
          description.setAttribute("hidden", "");
        }
        return;
      }

      if (open) {
        description.removeAttribute("hidden");
        var openHeight = description.scrollHeight;
        description.style.overflow = "hidden";
        description.animate(
          [
            { height: "0px", opacity: 0 },
            { height: openHeight + "px", opacity: 1 },
          ],
          { duration: 180, easing: "ease" }
        ).onfinish = function () {
          description.style.overflow = "";
        };
      } else {
        if (description.hasAttribute("hidden")) return;
        var closeHeight = description.scrollHeight;
        description.style.overflow = "hidden";
        description.animate(
          [
            { height: closeHeight + "px", opacity: 1 },
            { height: "0px", opacity: 0 },
          ],
          { duration: 160, easing: "ease" }
        ).onfinish = function () {
          description.style.overflow = "";
          description.setAttribute("hidden", "");
        };
      }
    }

    function getCartElement() {
      return document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    }

    function getCartSections(cart) {
      if (!cart || typeof cart.getSectionsToRender !== "function") return [];

      return cart.getSectionsToRender().map(function (section) {
        return section.id || section.section;
      }).filter(Boolean);
    }

    function getFallbackVariantId() {
      var selectors = [
        'body.product .main-product-section form[action*="/cart/add"] [name="id"]',
        'body.product .main-product-section product-form [name="id"]',
        'body.product .main-product-section [name="id"]',
      ];

      for (var i = 0; i < selectors.length; i += 1) {
        var input = document.querySelector(selectors[i]);
        if (input && input.value) return input.value;
      }

      return "";
    }

    function refreshCartIndicators() {
      return fetch("/cart.json")
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          if (cart.item_count === undefined) return;

          document.querySelectorAll(".cart-count").forEach(function (el) {
            if (el.classList.contains("cart-count-drawer")) {
              el.innerHTML = "(" + cart.item_count + ")";
            } else {
              el.innerHTML = cart.item_count > 100 ? "~" : cart.item_count;
            }
          });

          var headerTotalPrice = document.querySelector("header-total-price");
          if (headerTotalPrice && typeof headerTotalPrice.updateTotal === "function") {
            headerTotalPrice.updateTotal(cart);
          }

          var freeShipProgress = document.querySelector("free-ship-progress-bar");
          if (freeShipProgress && typeof freeShipProgress.init === "function") {
            freeShipProgress.init(cart.items_subtotal_price);
          }
        });
    }

    function updateCartDrawer(cart, parsedState) {
      if (!cart || !parsedState || !parsedState.sections || typeof cart.getSectionsToRender !== "function") {
        return false;
      }

      cart.getSectionsToRender().forEach(function (section) {
        var sectionId = section.id || section.section;
        var sectionHtml = parsedState.sections[sectionId];
        var elementToReplace = document.getElementById(sectionId);
        if (!sectionId || !sectionHtml || !elementToReplace) return;

        var html = new DOMParser().parseFromString(sectionHtml, "text/html");
        var minicartForm = html.querySelector("#minicart-form");

        if (minicartForm) {
          elementToReplace.innerHTML = minicartForm.innerHTML;
        } else {
          elementToReplace.innerHTML = sectionHtml;
        }

        var countdown = cart.querySelector(".cart-countdown-time");
        var htmlCountdown = html.querySelector(".cart-countdown-time");
        if (countdown && htmlCountdown) {
          countdown.innerHTML = htmlCountdown.innerHTML;
        }
      });

      cart.classList.remove("is-empty");

      if (typeof cart.cartAction === "function") {
        cart.cartAction();
      }

      return true;
    }

    function setAddButtonState(button, state, message) {
      if (!button) return;

      if (!button.dataset.pdpLayerOriginalHtml) {
        button.dataset.pdpLayerOriginalHtml = button.innerHTML;
      }

      button.classList.toggle("is-loading", state === "loading");
      button.classList.toggle("is-success", state === "success");
      button.classList.toggle("is-error", state === "error");

      if (state === "idle") {
        button.disabled = false;
        button.innerHTML = button.dataset.pdpLayerOriginalHtml;
        return;
      }

      button.disabled = state === "loading";
      if (message) {
        button.innerHTML = "<span>" + message + "</span>";
      }
    }

    function addProductToCart(button) {
      var variantId = button.getAttribute("data-variant-id") || getFallbackVariantId();
      if (!variantId) {
        setAddButtonState(button, "error", "UNAVAILABLE");
        window.setTimeout(function () {
          setAddButtonState(button, "idle");
        }, 1600);
        return;
      }

      var cart = getCartElement();
      var body = {
        id: Number(variantId),
        quantity: 1,
      };
      var sections = getCartSections(cart);

      if (sections.length) {
        body.sections = sections;
        body.sections_url = window.location.pathname;
      }

      setAddButtonState(button, "loading", "ADDING");

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(body),
      })
        .then(function (response) {
          return response.text().then(function (state) {
            var parsedState = state ? JSON.parse(state) : {};
            if (!response.ok || parsedState.message) {
              throw new Error(parsedState.description || parsedState.message || "Unable to add item.");
            }
            return parsedState;
          });
        })
        .then(function (parsedState) {
          var drawerUpdated = updateCartDrawer(cart, parsedState);

          return refreshCartIndicators()
            .catch(function () {
              return null;
            })
            .then(function () {
              document.dispatchEvent(
                new CustomEvent("pdp-layer-modal:cart-add", {
                  bubbles: true,
                  detail: {
                    item: parsedState,
                    variantId: variantId,
                  },
                })
              );

              if (cart && drawerUpdated && typeof cart.open === "function") {
                cart.open();
              }

              setAddButtonState(button, "success", "ADDED");
              window.setTimeout(function () {
                setAddButtonState(button, "idle");
              }, 1600);
            });
        })
        .catch(function (error) {
          console.error("PDP layer add to cart failed:", error);
          setAddButtonState(button, "error", "ERROR");
          window.setTimeout(function () {
            setAddButtonState(button, "idle");
          }, 1800);
        });
    }

    if (prevButton) {
      prevButton.addEventListener("click", function (event) {
        event.preventDefault();
        var activeSwiper = getActiveSwiper();
        if (activeSwiper && typeof activeSwiper.slidePrev === "function") {
          activeSwiper.slidePrev();
        }
      });
    }

    if (nextButton) {
      nextButton.addEventListener("click", function (event) {
        event.preventDefault();
        var activeSwiper = getActiveSwiper();
        if (activeSwiper && typeof activeSwiper.slideNext === "function") {
          activeSwiper.slideNext();
        }
      });
    }

    document.querySelectorAll("[data-pdp-layer-open]").forEach(function (trigger) {
      if (trigger.dataset.pdpLayerTriggerInit === "true") return;
      trigger.dataset.pdpLayerTriggerInit = "true";

      trigger.addEventListener("click", function (event) {
        event.preventDefault();
        openModal();
      });
    });

    closeEls.forEach(function (el) {
      el.addEventListener("click", function (event) {
        event.preventDefault();
        closeModal();
      });
    });

    groups.forEach(function (group) {
      var trigger = group.querySelector("[data-pdp-layer-group-trigger]");
      if (!trigger) return;

      trigger.addEventListener("click", function (event) {
        event.preventDefault();
        setActiveGroup(group);
      });
    });

    addButtons.forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        addProductToCart(button);
      });
    });

    // Create the first (visible) group's slider now; the remaining groups are
    // built lazily by ensureSwiper() when their accordion is opened.
    updateActiveSwiper();

    document.addEventListener("keydown", function (event) {
      if ((event.key === "Escape" || event.key === "Esc") && isOpen()) {
        closeModal();
      }
    });

    // Breakpoints change slidesPerView (1.18 / 2 / 2.65), which changes the
    // overflow/lock state. Re-sync the arrows on resize while the modal is open.
    var resizeTimer = null;
    window.addEventListener("resize", function () {
      if (!isOpen()) return;
      if (resizeTimer) window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(updateActiveSwiper, 150);
    });
  }

  function initAll(context) {
    var scope = context && context.querySelectorAll ? context : document;
    scope.querySelectorAll("[data-pdp-layer-modal]").forEach(initModal);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
